import { User } from "../types/user-types"
import { jsonToXml } from "../utils/xml"
import { systemPrompt } from "@/lib/user/system-prompt"




export function buildSystemPrompt({
    user,
    conversationSystemPrompt
}: {
    user: User,
    conversationSystemPrompt?: string
}) {
    console.log('\x1b[44m%s\x1b[0m', 'buildSystemPrompt', user.settings)
    const systemPrompts: Record<string, string> = {
        formattingInstructions: 'Always format your responses using proper markdown syntax unless the conversationSystemPrompt or userGeneralInstructions below instructs you otherwise. Use headers, lists, code blocks, emphasis, and other markdown elements to structure your content clearly'
    }

    if (conversationSystemPrompt && conversationSystemPrompt.trim() !== '') {
        systemPrompts.conversationSystemPrompt = conversationSystemPrompt
    } else {
        systemPrompts.userGeneralInstructions = user.settings.systemPrompt
    }

    const data = { systemPrompts }

    const xml = jsonToXml(data)
    return xml
}
